import { render, staticRenderFns } from "./Prueba.vue?vue&type=template&id=b4c9c91a&scoped=true&"
import script from "./Prueba.vue?vue&type=script&lang=js&"
export * from "./Prueba.vue?vue&type=script&lang=js&"
import style0 from "./Prueba.vue?vue&type=style&index=0&id=b4c9c91a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c9c91a",
  null
  
)

export default component.exports